function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'puck-black': 'rgb(0, 0, 0)','classic-navy': 'rgb(15, 46, 114)','goal-lamp-red': 'rgb(207, 0, 0)','goal-lamp-red-cosmetic-damage': 'rgb(207, 0, 0)','quack-attack-green': 'rgb(0, 178, 97)','quack-attack-green-cosmetic-damage': 'rgb(0, 178, 97)','blizzard-white': 'rgb(255, 255, 255)','black-with-3-velcro-patches-usa-canada-c-b-minor-defect': 'rgb(0, 0, 0)','gray-with-3-velcro-patches-usa-canada-c-b-minor-defect': 'rgb(111, 111, 111)','black-with-3-velcro-patches-usa-canada-c-b': 'rgb(0, 0, 0)','gray-with-3-velcro-patches-usa-canada-c-b': 'rgb(111, 111, 111)','neon-green': 'rgb(57, 255, 20)','charcoal-heather': 'rgb(74, 74, 74)','carbon-grey': 'rgb(187, 187, 187)','agave': 'rgb(159, 177, 173)','lime': 'rgb(208, 254, 29)','light-denim': 'rgb(59, 99, 140)','classic-denim': 'rgb(41, 64, 102)','heather-charcoal': 'rgb(74, 74, 74)','heather-grey': 'rgb(187, 187, 187)','camel': 'rgb(198, 159, 89)','almond': 'rgb(198, 159, 89)','mighty-eggplant': 'rgb(128, 0, 128)','lunar-grey': 'rgb(128, 128, 128)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
